const mEditionAssetContentsModalDeleteContent = {
  mEditionAssetContentsModalDeleteContent: {
    alerts: {
      deleteContenidoNodo: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'El contenido se eliminó exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ELIMINAR',

    messageDelete: {
      element: 'Se eliminará el contenido ',
      options: 'y todas sus características de forma definitiva.',
      notReversed: 'Esta acción no podrá ser revertida.'
    },

    title: 'Eliminar Contenido'
  }
}

export default mEditionAssetContentsModalDeleteContent
